import React, { useEffect, useRef, useState, useMemo } from "react";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Typography, Row, Col, Form } from "antd";

//
import log from "../../utils/log";
import c from "../../utils/common";
import moment from "moment-timezone";
import metaData from "../../data/metaData";
import _ from "lodash";
import { showErrMsg } from "../../utils/error";

//
import ProductProfileDisplay from "../ProductProfileDisplay";
import InventoryCard from "./InventoryCard";

const Overview = ({ state = {}, onChangeQty, onChangeRedeemShopIds }) => {
  const { data, form, onChange } = state;

  const [productForm] = Form.useForm();

  return (
    <Row justify="start" gutter={[16, 16]} style={{ width: "100%", margin: "1rem 0 5rem 0" }}>
      <Col span={12}>
        <ProductProfileDisplay
          state={{
            data: data,
            form: productForm,
            onChange: onChange,
          }}
          onChangeRedeemShopIds={onChangeRedeemShopIds}
        />
      </Col>
      <Col span={12}>
        <InventoryCard
          state={{
            data: data?.qty,
            form: productForm,
            // onChange: onChange,
          }}
          isReferral={data?.isReferral}
          productType={data?.type}
          isHidePrice={data?.isHidePrice}
          onChangeQty={onChangeQty}
        />
      </Col>
    </Row>
  );
};

export default Overview;
